import React from 'react'
import { useSelector } from 'react-redux'

const EditButton = ({ title, onClick }) => {
    const darkMode = useSelector(state => state.theme.darkMode);

    return darkMode
        ?
        <a className='btn btn-sm btn-success mr-2' onClick={onClick} style={{ cursor: 'pointer', color: '#fff', display: 'inline-block' }}>
            <i className="fas fa-edit" />
            <span style={{ marginLeft: 10 }}>{title}</span>
        </a>
        :
        <a
            className='pointer mr-2'
            onClick={onClick}
            style={{
                cursor: "pointer",
                color: "green",
                display: "inline-block",
            }}
        >
            <i className="fas fa-edit" />
            <span style={{ marginLeft: 10 }}>{title}</span>
        </a>
}

export default EditButton;